"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTapeBuilderRecordUI = exports.isTapeBuilderRecordDB = exports.isTapeBuilderRecordUI = exports.isTapeBuilderTask = exports.isTapeBuilderTaskWithTapeDefinition = exports.isTapeBuilderPreFilterTask = exports.isTapeBuilderSanitizeTask = exports.isTapeBuilderXlsx2CsvTask = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const common_1 = require("@finley-technologies/common");
const schema_1 = require("./schema");
const isTapeBuilderXlsx2CsvTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderXlsx2CsvTaskSchema);
    return result.valid;
};
exports.isTapeBuilderXlsx2CsvTask = isTapeBuilderXlsx2CsvTask;
const isTapeBuilderSanitizeTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderSanitizeTaskSchema);
    return result.valid;
};
exports.isTapeBuilderSanitizeTask = isTapeBuilderSanitizeTask;
const isTapeBuilderPreFilterTask = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderPreFilterTaskSchema);
    return result.valid;
};
exports.isTapeBuilderPreFilterTask = isTapeBuilderPreFilterTask;
const isTapeBuilderTaskWithTapeDefinition = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderTaskWithTapeDefinitionSchema);
    if (!result.valid) {
        (0, common_1.debugLog)('Not TapeBuilderTaskWithTapeDefinitionSchema:', result);
    }
    return result.valid;
};
exports.isTapeBuilderTaskWithTapeDefinition = isTapeBuilderTaskWithTapeDefinition;
const isTapeBuilderTask = (obj) => {
    // make a light check first to avoid heavy schema check
    if ('operation' in obj && typeof obj.operation === 'string') {
        const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderTaskSchema);
        if (!result.valid) {
            (0, common_1.debugLog)('Not TapeBuilderTaskSchema:', result);
        }
        return result.valid;
    }
    return false;
};
exports.isTapeBuilderTask = isTapeBuilderTask;
const isTapeBuilderRecordUI = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordUISchema, {
        nestedErrors: true,
    });
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        (0, common_1.debugLog)('isTapeBuilderRecordUI: not a tape-builder record ui:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordUI = isTapeBuilderRecordUI;
const isTapeBuilderRecordDB = (obj) => {
    // we call this at runtime, must strip of the db timestamp fields
    // before calling validating this.
    const result = jsonschema_1.default.validate(common_1.utils.stripDbTimeStamps(obj), schema_1.schema.TapeBuilderRecordDBSchema, {
        nestedErrors: true,
    });
    if (!result.valid) {
        // this is an important log statement needed for debugging,
        // do not remove while we are still developing tape-builder
        (0, common_1.debugLog)('not a tape-builder db record db:', result);
    }
    return result.valid;
};
exports.isTapeBuilderRecordDB = isTapeBuilderRecordDB;
// This is not strictly a typeguard in the sense that it doesn't return a boolean.
const validateTapeBuilderRecordUI = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema_1.schema.TapeBuilderRecordUISchema);
    if (!result.valid) {
        (0, common_1.debugLog)('validateTapeBuilderRecordUI: not a tape-builder record ui:', result);
    }
    return {
        isValid: result.valid,
        // TODO: add more info to error messages
        errorMessages: result.errors.map((error) => error.message),
    };
};
exports.validateTapeBuilderRecordUI = validateTapeBuilderRecordUI;
//# sourceMappingURL=typeguards.js.map